module.exports = new __parcel__URL__("logo-dark.38dfd0ed.png").toString();